import type { Feature, FeatureModule } from '../../../types';
import { featureList } from '../../helpers';
import { DATA_BRIDGE_FEATURE_GROUP } from './group';

export const DATA_BRIDGE_FEATURES = {
  ACCESS: {
    guid: '61f1f20e-9f8b-43a3-8160-caeee55f0001',
    name: 'data-bridge:access',
    description: 'Access the Data Bridge app',
    action: 'read',
    product: 'app',
    parentGuid: DATA_BRIDGE_FEATURE_GROUP.guid,
  },
} as const satisfies Record<string, Feature>;

export { DATA_BRIDGE_FEATURE_GROUP } from './group';

export const DATA_BRIDGE_MODULE: FeatureModule = {
  product: 'app',
  groups: [DATA_BRIDGE_FEATURE_GROUP],
  features: featureList(DATA_BRIDGE_FEATURES),
};
